module.exports = __webpack_public_path__ + "img/startupmate.e4ca0dd4.png";